export default function companiesRouter(
  $stateProvider
){
  'ngInject';
  $stateProvider
    .state({
        name: 'adminCompanies',
        url: '/admin/companies',
        template: '<admin-companies></admin-companies>',
      })
      .state({
        name: 'adminCompanies.detail',
        url: '/:id/detail/:target',
        views: {
          "nested": {
            template: '<companies-detail></companies-detail>'
          }
        }
      })
      .state({
        name      : 'adminCompanies.create',
        url       : '/create',
        views: {
          "nested": {
            template  : '<companies-create></companies-create>'
          }
        }
      })
      .state({
        name: 'adminCompanies.update',
        url: '/:id/update',
        views: {
          "nested": {
            template: '<companies-update></companies-update>'
          }
        }
      })
}


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies.router.js
 **/